// extracted by mini-css-extract-plugin
export default {"table":"SelectReferralDocumentsList_table__F4ovp"};